(() => {
  'use strict';
  if (window.UrbanInkLeadAnalytics) return;
  const measurementId = 'G-YG6M7CNRBY';
  const version = '20260926.2';
  const sourceScript = document.currentScript?.src || '';
  const services = {
    '147209': 'Tattoo', '161572': 'Tattoo',
    '158593': 'Piercing', '161569': 'Piercing',
    VivianAppointment: 'Brows & Lips',
  };
  const seen = new WeakSet();
  const pmuKey = 'urban-pmu-confirmed-submit-v1';
  let pending = [];
  let privacyRequested = false;
  let bridgeRequested = false;
  let privacyAttempts = 0;

  function permission(method) {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.[method] !== 'function') return null;
    try { return privacy[method]() === true; } catch { return false; }
  }

  function googleEvent(name, parameters) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, parameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      (function () { window.dataLayer.push(arguments); })('event', name, parameters);
    }
  }

  function flush() {
    const allowed = permission('analyticsProcessingAllowed');
    if (allowed === null) return;
    const batch = pending;
    pending = [];
    for (const item of batch) {
      if (!allowed || Date.now() - item.createdAt > 60000) {
        item.form.dataset.urbanAnalyticsTransport = 'not_sent_consent';
        continue;
      }
      const parameters = {
        send_to: measurementId,
        form_id: item.formId,
        form_provider: item.formId === 'VivianAppointment' ? 'shopify_contact' : 'powerful_form_builder',
        service: services[item.formId],
        page_path: item.path,
        page_location: window.location.origin + item.path,
        tracking_version: version,
        allow_ad_personalization_signals:
          permission('marketingAllowed') === true && permission('saleOfDataAllowed') === true,
      };
      googleEvent('globo_form_submit', parameters);
      item.form.dataset.urbanAnalyticsTransport = 'ga4_queued';
      item.form.dataset.urbanAnalyticsVersion = version;
    }
  }

  function send(form, formId) {
    if (!(form instanceof HTMLFormElement) || !services[formId] || seen.has(form)) return;
    seen.add(form);
    pending.push({ form, formId, path: window.location.pathname, createdAt: Date.now() });
    flush();
    ensurePrivacy();
  }

  function restoreSourceBridge() {
    if (bridgeRequested || window.__urbanInkGloboAttributionBridgeV2 || !sourceScript) return;
    let url;
    try {
      url = new URL(sourceScript, window.location.href);
      if (url.origin !== window.location.origin || !url.pathname.endsWith('/urban-form-attribution.js')) return;
      url.pathname = url.pathname.replace(/urban-form-attribution\.js$/, 'urban-attribution-bridge-v2.js');
      url.search = '?v=tracking-repair-20260926';
    } catch { return; }
    bridgeRequested = true;
    const script = document.createElement('script');
    script.src = url.href;
    script.defer = true;
    script.dataset.urbanAttributionBridge = version;
    script.addEventListener('load', () => {
      for (const form of document.querySelectorAll('form')) {
        const id = String(form.getAttribute('action') || '').match(/\/api\/front\/form\/(\d+)\/send(?:[?#]|$)/)?.[1];
        if (id && services[id]) window.__urbanInkGloboAttributionBridgeV2?.writeForm(form, id);
      }
    }, { once: true });
    document.head.appendChild(script);
  }

  function checkPmuSuccess() {
    const form = document.querySelector('form#VivianAppointment.pmu-booking-form');
    if (!form || !form.querySelector('[data-pmu-success]') || form.hasAttribute('data-preview')) return;
    if (permission('analyticsProcessingAllowed') !== true) return;
    try {
      const marker = JSON.parse(window.sessionStorage.getItem(pmuKey) || 'null');
      window.sessionStorage.removeItem(pmuKey);
      if (!marker || Date.now() < marker.at || Date.now() - marker.at > 3600000) return;
      send(form, 'VivianAppointment');
    } catch {}
  }

  function ensurePrivacy() {
    if (permission('analyticsProcessingAllowed') !== null) {
      restoreSourceBridge();
      flush();
      checkPmuSuccess();
      return;
    }
    if (privacyRequested || privacyAttempts >= 10) return;
    privacyAttempts += 1;
    if (typeof window.Shopify?.loadFeatures !== 'function') {
      window.setTimeout(ensurePrivacy, 500);
      return;
    }
    privacyRequested = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      privacyRequested = false;
      if (!error && permission('analyticsProcessingAllowed') !== null) {
        restoreSourceBridge();
        flush();
        checkPmuSuccess();
      } else if (privacyAttempts < 10) {
        window.setTimeout(ensurePrivacy, 500);
      }
    });
  }

  function rememberPmuAttempt(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'VivianAppointment') return;
    if (event.defaultPrevented || form.hasAttribute('data-preview') || !form.checkValidity()) return;
    if (form.querySelector('[data-pmu-trap]')?.value) return;
    if (permission('analyticsProcessingAllowed') !== true) return;
    try { window.sessionStorage.setItem(pmuKey, JSON.stringify({ at: Date.now() })); } catch {}
  }
  document.addEventListener('submit', rememberPmuAttempt);
  document.addEventListener('formdata', rememberPmuAttempt, true);
  document.addEventListener('visitorConsentCollected', ensurePrivacy);
  document.addEventListener('globo.formbuilder.form.reset', (event) => {
    const form = event?.detail?.form;
    if (form instanceof HTMLFormElement) {
      seen.delete(form);
      delete form.dataset.urbanAnalyticsTransport;
    }
  });
  window.UrbanInkLeadAnalytics = Object.freeze({ send, version });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensurePrivacy, { once: true });
  } else {
    ensurePrivacy();
  }
})();

(() => {
  'use strict';

  const STORAGE_KEY = 'urban-ink-landing-attribution-v1';
  const ATTRIBUTION_PARAMS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const FORM_ID_FROM_ACTION = /\/api\/front\/form\/(\d+)\/send(?:[?#]|$)/;
  const FORM_EVENT_DETAILS = {
    '147209': { event: 'globo_form_submit', service: 'Tattoo' },
    '161572': { event: 'globo_form_submit', service: 'Tattoo' },
    '158593': { event: 'globo_form_submit', service: 'Piercing' },
    '161569': { event: 'globo_form_submit', service: 'Piercing' },
    '153381': { event: 'intake_form_submit', service: 'Intake' },
  };
  // The live Globo configurations expose these provider-owned attribution fields.
  // Do not create a field or reuse a routing field when it is absent.
  const ATTRIBUTION_FIELDS = {
    '147209': ['hidden-3'],
    '161572': ['hidden-3'],
    '158593': ['hidden-2'],
    '161569': ['hidden-2'],
  };
  const submittedForms = new WeakSet();

  if (window.__urbanInkFormAttributionLoaded) return;
  window.__urbanInkFormAttributionLoaded = true;

  function cleanValue(value) {
    return String(value || '').trim().slice(0, 512);
  }

  function readStoredAttribution() {
    try {
      const value = window.sessionStorage.getItem(STORAGE_KEY);
      const parsed = value ? JSON.parse(value) : {};
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
      return ATTRIBUTION_PARAMS.reduce((result, key) => {
        const entry = cleanValue(parsed[key]);
        if (entry) result[key] = entry;
        return result;
      }, {});
    } catch (_error) {
      return {};
    }
  }

  function storeAttribution(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (_error) {
      // Attribution is progressive enhancement; do not block a booking if storage is unavailable.
    }
  }

  function captureLandingAttribution() {
    const stored = readStoredAttribution();
    let url;
    try {
      url = new URL(window.location.href);
    } catch (_error) {
      return stored;
    }

    let changed = false;
    ATTRIBUTION_PARAMS.forEach((key) => {
      if (stored[key]) return;
      const value = cleanValue(url.searchParams.get(key));
      if (!value) return;
      stored[key] = value;
      changed = true;
    });
    if (changed) storeAttribution(stored);
    return stored;
  }

  function attributionValue() {
    const params = new URLSearchParams();
    const stored = readStoredAttribution();
    ATTRIBUTION_PARAMS.forEach((key) => {
      if (stored[key]) params.set(key, stored[key]);
    });
    return params.toString();
  }

  function appendAttribution(urlOrHref) {
    let url;
    try {
      url = urlOrHref instanceof URL
        ? new URL(urlOrHref.toString())
        : new URL(String(urlOrHref || ''), window.location.href);
    } catch (_error) {
      return urlOrHref;
    }
    if (url.origin !== window.location.origin) return url;

    const stored = readStoredAttribution();
    ATTRIBUTION_PARAMS.forEach((key) => {
      if (stored[key] && !url.searchParams.has(key)) url.searchParams.set(key, stored[key]);
    });
    return url;
  }

  function normalizeFormId(value) {
    const raw = String(value || '').trim();
    if (/^\d+$/.test(raw)) return raw;
    try {
      const decoded = window.atob(raw).trim();
      return /^\d+$/.test(decoded) ? decoded : '';
    } catch (_error) {
      return '';
    }
  }

  function formIdFor(form) {
    if (!(form instanceof HTMLFormElement)) return '';
    const actionId = String(form.getAttribute('action') || '').match(FORM_ID_FROM_ACTION)?.[1] || '';
    if (actionId) return actionId;
    const host = form.closest('.globo-formbuilder, [id^="globo-formbuilder-"]');
    const dataId = host?.getAttribute('data-id') || '';
    const idFromHost = host?.id?.replace('globo-formbuilder-', '') || '';
    return normalizeFormId(dataId || idFromHost);
  }

  function formFromEvent(event) {
    const form = event?.detail?.form;
    return form instanceof HTMLFormElement ? form : null;
  }

  function injectAttribution(form) {
    const formId = formIdFor(form);
    const bridge = window.__urbanInkGloboAttributionBridgeV2;
    if (bridge && ATTRIBUTION_FIELDS[formId]) {
      bridge.writeForm(form, formId);
      return;
    }
    const fieldNames = ATTRIBUTION_FIELDS[formId];
    const value = attributionValue();
    if (!fieldNames || !value) return;

    const hiddenInputs = Array.from(form.querySelectorAll('input[type="hidden"][name]'));
    hiddenInputs.forEach((input) => {
      if (!fieldNames.includes(input.name) || input.value === value) return;
      input.value = value;
      input.dataset.urbanAttributionInjected = 'true';
      // Intentionally do not dispatch input/change: this is attribution metadata,
      // not visitor interaction and must not produce a start-of-form signal.
    });
  }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function useVerifiedFormSuccessEvents() {
    let configured = false;
    Object.entries(FORM_EVENT_DETAILS).forEach(([formId, details]) => {
      const definition = window.Globo?.FormBuilder?.forms?.[formId];
      const afterSubmit = (definition?.[formId] || definition)?.afterSubmit;
      if (!afterSubmit) return;

      // The live provider configuration emits its own generic GA event after a
      // submit. Disable only that duplicate GA dispatch; retain the provider's
      // form lifecycle event and publish one named dataLayer event after its
      // verified success signal instead.
      afterSubmit.enableGa = false;
      if (formId === '153381') afterSubmit.gaEventName = details.event;
      configured = true;
    });
    return configured;
  }

  function onFormLoaded(event) {
    const form = formFromEvent(event);
    if (form) injectAttribution(form);
  }

  function onFormSubmitting(event) {
    const form = formFromEvent(event);
    if (form) injectAttribution(form);
  }

  function onFormSubmitted(event) {
    const form = formFromEvent(event);
    if (!form) return;
    const formId = formIdFor(form);
    const details = FORM_EVENT_DETAILS[formId];
    if (!details || submittedForms.has(form)) return;

    submittedForms.add(form);
    form.dataset.urbanAnalyticsSubmitted = details.event;
    if (details.event === 'globo_form_submit') {
      window.UrbanInkLeadAnalytics.send(form, formId);
      return;
    }
    pushDataLayer({
      event: details.event,
      form_id: formId,
      form_provider: 'powerful_form_builder',
      service: details.service,
      page_path: window.location.pathname,
    });
  }

  function onFormReset(event) {
    const form = formFromEvent(event);
    if (!form) return;
    submittedForms.delete(form);
    delete form.dataset.urbanAnalyticsSubmitted;
  }

  function scanForms(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    if (root instanceof HTMLFormElement) injectAttribution(root);
    root.querySelectorAll('form').forEach(injectAttribution);
  }

  function normalizeService(value) {
    const normalized = String(value || '').toLowerCase();
    if (normalized.includes('pierc')) return 'Piercing';
    if (normalized.includes('intake')) return 'Intake';
    return normalized.includes('tattoo') || normalized.includes('flash') ? 'Tattoo' : '';
  }

  function ctaForEventTarget(target) {
    if (!(target instanceof Element)) return null;
    return target.closest([
      '[data-urban-cta]',
      '[data-urban-booking-open]',
      '[data-urban-booking-service]',
      'a[href*="#UrbanBookingSheet"]',
      'a[href*="#UrbanBook"]',
      'a[href*="#custom-tattoo-consultation"]',
    ].join(','));
  }

  function ctaText(element) {
    const raw = element.getAttribute('data-urban-cta-label') || element.getAttribute('aria-label') || element.textContent || '';
    return raw.replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function ctaLocation(element) {
    const explicit = element.getAttribute('data-urban-cta-location');
    if (explicit) return explicit.slice(0, 120);
    if (element.closest('[data-urban-booking-bar]')) return 'global_booking_bar';
    if (element.closest('[data-urban-booking-component]')) return 'global_booking_component';
    const section = element.closest('[data-section-id], section[id], .shopify-section[id]');
    return section?.getAttribute('data-section-id') || section?.id || window.location.pathname;
  }

  function ctaServiceAndFormId(element) {
    const anchor = element.closest('a[href]');
    let url;
    try {
      url = anchor ? new URL(anchor.href, window.location.href) : null;
    } catch (_error) {
      url = null;
    }
    const explicitFormId = normalizeFormId(element.getAttribute('data-urban-form-id'));
    const service = normalizeService(
      element.getAttribute('data-urban-booking-service') ||
      element.getAttribute('data-urban-service') ||
      url?.searchParams.get('service') ||
      ''
    );
    const formId = explicitFormId || (service === 'Piercing' ? '158593' : service === 'Tattoo' ? '147209' : '');
    return { service, formId };
  }

  function onCtaClick(event) {
    if (!event.isTrusted || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cta = ctaForEventTarget(event.target);
    if (!cta) return;

    const anchor = cta.closest('a[href]');
    if (anchor) {
      const destination = appendAttribution(anchor.href);
      if (destination instanceof URL && destination.origin === window.location.origin) {
        anchor.href = destination.toString();
      }
    }

    const context = ctaServiceAndFormId(cta);
    pushDataLayer({
      event: 'cta_clicked',
      button_text: ctaText(cta),
      location: ctaLocation(cta),
      service: context.service,
      form_id: context.formId,
    });
  }

  captureLandingAttribution();
  useVerifiedFormSuccessEvents();
  window.UrbanInkAttribution = Object.freeze({
    appendToUrl: appendAttribution,
    get: readStoredAttribution,
  });

  document.addEventListener('globo.formbuilder.form.loaded', onFormLoaded);
  document.addEventListener('globo.formbuilder.form.beforeSubmit', onFormSubmitting);
  document.addEventListener('globo.formbuilder.form.submitting', onFormSubmitting);
  document.addEventListener('globo.formbuilder.form.submitted', onFormSubmitted);
  document.addEventListener('globo.formbuilder.form.reset', onFormReset);
  document.addEventListener('globo.formbuilder.scripts.loaded', useVerifiedFormSuccessEvents);
  document.addEventListener('click', onCtaClick, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanForms(document), { once: true });
  } else {
    scanForms(document);
  }
})();
